<app-grid [maxColumns]="4" [location]="'main'" [type]="'article'"></app-grid>
